import { Component, Input, OnChanges } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
  selector: "app-custom-dropdown",
  templateUrl: "./custom-dropdown.component.html",
  styleUrls: ["./custom-dropdown.component.scss"],
})
export class CustomDropdownComponent implements OnChanges {
  @Input() defaultWidth: boolean = true;
  @Input() label = "";
  @Input() required = false;
  @Input() options: string[] = [];
  @Input() control!: FormControl;
  @Input() multiple: boolean = false;

  /** Resolves WCAG 4.1.2: mat-select value container is empty until selections exist. */
  get selectAriaLabel(): string {
    const text = this.label?.trim();
    if (text) {
      return this.required ? `${text}, required` : text;
    }
    return this.multiple ? "Multi-select options" : "Select an option";
  }

  ngOnChanges() {
    if (this.control.value) {
      this.updateValue(this.control.value);
    }
  }

  updateValue(value: string) {
    this.control.setValue(value);
  }
}
